import React, { useEffect } from 'react'
import { connect, useDispatch } from 'react-redux'
import { Link } from 'react-router-dom'

const loadBrands = () => ({
  type: 'LOAD_BRANDS',
  payload: {
    request: {
      url: `/v3/disc/brands`,
    },
  },
})

// Public disc-brand catalog. Loads independently of the user's discs so it works even
// when signed out.
function Brands({ brands, loading, loaded }) {
  const dispatch = useDispatch()

  useEffect(() => {
    if (!loaded && !loading) {
      dispatch(loadBrands())
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [loaded])

  if (loading && brands.length === 0) {
    return <p className="discs-empty">Loading brands…</p>
  }

  const sorted = [...brands].sort((a, b) => a.nm.localeCompare(b.nm))

  return (
    <div className="brands-grid">
      {sorted.map((brand) => {
        const discCount = (brand.di || []).length
        const plasticCount = (brand.pl || []).length
        const count = (
          <>
            <span className="brand-card--name">{brand.nm}</span>
            <span className="brand-card--count">
              {discCount} discs · {plasticCount} plastics
            </span>
          </>
        )

        // Nothing to drill into — render a muted, non-clickable card.
        if (discCount === 0 && plasticCount === 0) {
          return (
            <div
              key={brand.k}
              className="brand-card brand-card--disabled"
              aria-disabled="true"
            >
              {count}
            </div>
          )
        }

        return (
          <Link
            key={brand.k}
            to={`/discs/brands/${brand.k}`}
            className="brand-card"
          >
            {count}
          </Link>
        )
      })}
    </div>
  )
}

const mapStateToProps = (state) => ({
  brands: state.brands.data,
  loading: state.brands.loading,
  loaded: state.brands.loaded,
})

export default connect(mapStateToProps)(Brands)
